/**
 * Base class for client-server processing
 * 
 * Helper:https://github.com/axios/axios/issues/897#issuecomment-343715381
 */
import Vue from 'vue'
import CONFIG from '@/constants/config.js';
export default class{

    static mockIfDebug(oriPromise){

        if(CONFIG.DEBUG){
            return new Promise((resolve) => {
                setTimeout(()=>{
                    resolve();
                },500);
            });
        }

        return oriPromise;
    }

    static mockDebugUrl(url){
        return CONFIG.URL_PREFIX+url;
    }

    static userIsLoggedIn(){
        try{
            return JSON.parse(localStorage.getItem('app-storage')).settings.app_logged_in;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static handleUnauthorizationIf403(error,url){

        if(error && error.response && (error.response.status==403 || error.response.status==401)){
            console.log(url);
            if(this.$router){
                this.$router.push({ path: `/login`});
            }else if(window.location.pathname !="/login"){
                //Quick fix to logout user if there is an error
                
                if(this.userIsLoggedIn()){
                    window.location = "/login";
                }
            }
        }
    }

    static get(url,data,typeName,redirectToLoginIfError=true){
        return this.mockIfDebug(new Promise((resolve,reject) => {

            Vue.axios(this.mockDebugUrl(url), {
                method: "get",
                data: data,
                baseURL: '/',
                withCredentials: (process.env.NODE_ENV === 'development'),
              }).then((response)=>{
                console.log(`${typeName} success`);
                resolve(response);
            })
            .catch( (error) =>{
                console.log(`${typeName} error`);
                console.warn(error);
                reject(error);
                if(redirectToLoginIfError){
                    this.handleUnauthorizationIf403(error,url);
                }
            });
        }));
    }
    static delete(url,data,typeName){
        Vue.axios.defaults.withCredentials = (process.env.NODE_ENV === 'development');
        return this.mockIfDebug(new Promise((resolve,reject) => {
            Vue.axios.delete(this.mockDebugUrl(url), {
                withCredentials: (process.env.NODE_ENV === 'development'),
                baseURL: '/',
                data: data
            })
            .then((response)=>{
                console.log(`${typeName} success`);
                resolve(response);
            })
            .catch( (error) =>{
                console.log(`${typeName} error`);
                console.warn(error);
                reject(error);
                this.handleUnauthorizationIf403(error,url);
            });
        }));
    }
    static post(url,data,typeName,redirectToLoginIfError=true){
        return this.mockIfDebug(new Promise((resolve,reject) => {
        Vue.axios.defaults.withCredentials = (process.env.NODE_ENV === 'development');
        Vue.axios(this.mockDebugUrl(url), {
            method: "post",
            data: data,
            baseURL: '/',
            withCredentials: (process.env.NODE_ENV === 'development')
          }).then((response)=>{
            console.log(`${typeName} success`);
            resolve(response);
        })
        .catch( (error) =>{
            console.log(`${typeName} error`);
            console.warn(error);
            reject(error);
            if(redirectToLoginIfError){
                this.handleUnauthorizationIf403(error,url);
            }
        });
    }));
    }
}